<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Sl</th>
                        <th>Date</th>
                        <th>Order Number</th>
                        <th>Total Amount</th>
                        <th>Discount Amount</th>
                        <th>Net Amount</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, i) in tableItems" :key="i">
                        <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                        <td>{{ item.date }} </td>
                        <td>{{ item.bill_number }}</td>
                        <td class="text-right">{{ item.total_amount ? commaFormat(item.total_amount) : '' }}</td>
                        <td class="text-right">{{ item.discount_amount ? commaFormat(item.discount_amount) : '' }}</td>
                        <td class="text-right">{{ commaFormat(item.total_amount - item.discount_amount) }}</td>
                    </tr>
                    <tr v-if="currentPage === lastPage">
                      <td colspan="3" class="text-right">Total</td>
                      <td class="text-right"> {{ totalValue && totalValue.total_total_amount }}</td>
                      <td class="text-right"> {{ totalValue && totalValue.total_discount_amount }}</td>
                      <td class="text-right"> {{ totalValue && totalValue.total_net_amount }}</td>

                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";

const {commaFormat} = figureFormatter();

const props = defineProps({
    tableItems: {
        type: Array,
    },
    currentPage: Number,
    lastPage: Number,
    perPage: Number,
    totalValue: Object,
})
</script>
